<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/ZOOM_ROOMS/mixin';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';
import { PLAN_TYPES_WITH_MULTI_BASE_PLANS } from '@/plans/ROOM_CONNECTOR/common/utils';
import { pageConfig } from '@/common/service/page-config';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import {
  canRemoveMeetingPlanInWinBack,
  isFromShoppingCart, isMeetingPlanDisabledByHasAddOn,
} from '@/views/config/shopping-cart/persist/plan-remove';
import {  planTypes } from '@/common/constants';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import { mapGetters } from 'vuex';

export default {
  mixins: [mixin, commonMixin],
  name: 'ZoomRoomCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    showRemove() {
      // Hack: plan remove logic places in mx_remove when the user is from shopping bag
      if(isFromShoppingCart()) {
        return true;
      }
      const hasBizOrEdu = this.getSelectedPlans.some(item => item.type === planTypes.ZOOM_MEETING && [ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_INR, ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP].includes(item.zoomMeetingCategory));
      const hasAudio = this.getSelectedPlans.some(item => item.type === planTypes.TOLLFREE);
      const hasRoom = this.getSelectedPlans.some(item => item.type === planTypes.ZOOM_ROOMS);
      //unlimit audio depend bizOrEdu && room
      if (hasBizOrEdu && hasAudio && hasRoom) {
        return false;
      }
      if (isMeetingPlanDisabledByHasAddOn(planTypes.ZOOM_ROOMS)) {
        return false;
      }
      const { from: currentPrimaryPlan } = pageConfig;
      // Some plan may has more than 1 base plan dependencies like CRC
      const hasThePlanNeedsMultiBasePlan = PLAN_TYPES_WITH_MULTI_BASE_PLANS.includes(currentPrimaryPlan);
      if(hasThePlanNeedsMultiBasePlan) {
        return !this.mx_isLastBasePlanForTheSameBillingCycle
      }
      return !this.mx_isLastBasePlan || canRemoveMeetingPlanInWinBack(planTypes.ZOOM_ROOMS)
    }
  },
  methods: {
    mx_license(num) {
      return (
        <div class="opc-cart-item__text">
          {num} {getPlanUnitWithQuantity(planUnitMap.room)}
        </div>
      );
    },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(
                  this.title,
                  <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>,
                )}
                <AltProratedPlanUser type={plan.type}>
                  {this.mx_license(plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                {this.showRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
